import api from '../auth';
const slug = 'api/users/';

const UsersService = () => {
    const getUserss = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getUsersSimple = () => {
        return api.get(slug + `simple`).then((res) => res.data);
    };

    const getUserssLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getUsers = (id) => {
        return api.get(slug + `show/${id}`).then((res) => res.data);
    };

    const deleteUsers = (id) => {
        return api
            .delete(slug + `${id}`)
            .then((res) => res.data)
            .catch((err) => {
                return err;
            });
    };

    const createUsers = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updateUsers = (id, data) => {
        return api.put(slug + `${id}`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyUsers = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    // uploadSignatureImage
    const uploadSignatureImage = (id, data) => {
        return api
            .post(slug + `${id}/upload-signature-image`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((res) => res.data);
    };

    return {
        getUserss,
        getUsersSimple,
        getUserssLazy,
        getUsers,
        deleteUsers,
        createUsers,
        updateUsers,
        getOptions,
        copyUsers,
        uploadSignatureImage
    };
};

export default UsersService;
